import React, { ReactNode } from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'

import styles from './styles'
import HGText from './HGText'

type Props = {
  title?: string | null
  transparentMode?: boolean
  noPadding?: false
  children: ReactNode
  style: unknown
}

const HGGroup = (props: Props) => {
  const {
    children,
    title = null,
    transparentMode = false,
    noPadding = false,
    style,
  } = props

  return (
    <View style={[styles.groupContainer, style]}>
      {title && <HGText style={styles.groupTitle}>{title}</HGText>}

      <View
        style={[
          styles.groupContainerBox,
          transparentMode && styles.boxTransparent,
          noPadding && styles.boxNoPadding,
        ]}
      >
        {children}
      </View>
    </View>
  )
}

HGGroup.propTypes = {
  title: PropTypes.string,
  noPadding: PropTypes.bool,
  transparentMode: PropTypes.bool,
}

HGGroup.defaultTypes = {
  title: '',
  noPadding: false,
  transparentMode: false,
}

export default HGGroup
